import { css } from 'linaria';

export const retryButtonContainer = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const retryButton = css`
  --button-bg: #ffffff !important;
`;

export const retryButtonIcon = css`
  width: 20px;
  height: 20px;
  fill: var(--control-primary, #464c5c);
`;
